/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { defaultThemeValues } from "../styles"
import { useLoginLogout } from "../hooks"
import { Card, CardContent, IconButton, Typography } from "@material-ui/core"
import { CloseOutlined } from "@material-ui/icons"
import { useState } from "react"
import { isDeviceMobile } from "../utils/utils"

export default function NewsBanner() {
    const { isAuthenticated } = useLoginLogout()

    if (isDeviceMobile()) {
        return null
    }

    if (!isAuthenticated) {
        return null
    }

    return <RetailerNews />
}

const RETAILER_CONTENT: {
    title: string
    bullets?: string[]
    footer?: string
} = {
    title: "Novemberi 10% akció",
    bullets: [
        "Egy számlán szereplő összes termékre 10% kedvezmény vagy az árlistában szereplő mennyiségi ár érvényesíthető.",
        "Részletekért keresse a területi képviselőket.",
        "Az akció 2026.11.01-től 2026.11.30-ig vagy a készlet erejéig tart.",
    ],
}

function RetailerNews() {
    const [isOpen, setIsOpen] = useState(true)
    if (!isOpen) {
        return null
    }

    return (
        <Card css={styles.card}>
            <CardContent>
                <div css={styles.iconContainer}>
                    <IconButton
                        aria-label="close"
                        size="small"
                        onClick={() => setIsOpen(false)}
                    >
                        <CloseOutlined fontSize="inherit" />
                    </IconButton>
                </div>
                <Typography css={styles.title} variant="h5" component="h2">
                    {RETAILER_CONTENT.title}
                </Typography>
                <Typography css={styles.pos}>
                    {RETAILER_CONTENT.bullets?.map((item, index) => (
                        <span key={index} css={styles.bulletText}>
                            <span css={styles.bullet}>•</span>
                            {item}
                            <br />
                        </span>
                    ))}
                </Typography>
                <Typography variant="body2" component="p" css={styles.footer}>
                    {RETAILER_CONTENT?.footer}
                </Typography>
            </CardContent>
        </Card>
    )
}

const styles = {
    card: css`
        width: 275px;
        position: absolute;
        top: 2.5rem;
        right: 1rem;
        z-index: 120;
        ${defaultThemeValues.mediaQuery.desktop.default} {
            position: fixed;
        }
    `,
    iconContainer: css`
        display: flex;
        justify-content: flex-end;
        margin-bottom: -10px;
    `,
    title: css`
        font-size: ${defaultThemeValues.fontSizes.xLarge};
        color: ${defaultThemeValues.colors.primary[800]};
        font-weight: bold;
        margin-bottom: 12px;
    `,
    bullet: css`
        display: inline-block;
        margin: 0 2px;
        transform: scale(0.8);
    `,
    bulletText: css`
        font-size: ${defaultThemeValues.fontSizes.medium};
    `,
    pos: css`
        margin-bottom: 1.5rem;
        display: flex;
        gap: 1rem;
        flex-direction: column;
        color: ${defaultThemeValues.colors.grey[900]};
    `,
    footer: css`
        color: ${defaultThemeValues.colors.grey[700]};
        font-size: ${defaultThemeValues.fontSizes.default};
    `,
}
